import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(4),
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    letterSpacing: 1,
    marginBottom: theme.spacing(3),
  },
  inner: {
    display: 'flex',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      gap: theme.spacing(3),
    },
  },
  avatarColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 160,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
      width: '100%',
    },
  },
  avatar: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    backgroundColor: theme.palette.grey[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1.5),
  },
  avatarLetters: {
    fontSize: 28,
    fontWeight: 700,
    color: theme.palette.primary.contrastText,
  },
  displayName: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  displayEmail: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    wordBreak: 'break-all',
  },
  formColumn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  field: {},
  saveRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  saveButton: {
    textTransform: 'none',
    borderRadius: 6,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))

export default useStyles
